(() => {
  function getSectionRoot(el) {
    return (
      el.closest('[id^="shopify-section-"]') ||
      el.closest('[data-section-id]') ||
      el.closest('.shopify-section') ||
      el.closest('section') ||
      document
    );
  }

  function hasVariantUIInRoot(root) {
    // Any typical option selectors (radio swatches, selects)
    return !!root.querySelector(
      'variant-selects fieldset input[type="radio"], variant-selects select, .product-form__input fieldset input[type="radio"], .product-form__input select'
    );
  }

  function initStablePrice() {
    document.querySelectorAll('.price-stable').forEach((stable) => {
      const root = getSectionRoot(stable);

      // If there's no variant UI at all, show immediately (no skeleton)
      if (!hasVariantUIInRoot(root)) {
        stable.classList.add('is-ready');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStablePrice);
  } else {
    initStablePrice();
  }
})();
